
import { defineComponent, PropType } from 'vue'
import { AuditLogResources } from '@/modules/audit-logs/types'
import ResourceLink from '@/components/_shared/links/resource-link.vue'

export default defineComponent({
    name: 'audit-log-resources',
    components: { ResourceLink },
    props: {
        resources: {
            type: Array as PropType<AuditLogResources[]>,
            required: true
        }
    }
})
